import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pw-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.scss'],
})
export class CellComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
